import { Platform, StyleSheet } from "react-native";

import { spacing, useThemedStyles, type ThemeColors } from "~/styles/theme";
import { getExternalLinks } from "~/utils/runtime-config";
import { AppLink } from "./AppLink";
import { AppText } from "./AppText";
import { Row } from "./Row";

export function WebFooter({
  tone = "default",
}: {
  tone?: "default" | "inverse";
}) {
  const stylesheet = useThemedStyles(makeStyles);
  if (Platform.OS !== "web") return null;

  const externalLinks = getExternalLinks();
  const footerLinks = [
    { href: externalLinks.privacyPolicy, label: "Privacy Policy" },
    { href: externalLinks.terms, label: "Terms" },
    { href: externalLinks.facebook, label: "Facebook" },
    { href: externalLinks.instagram, label: "Instagram" },
  ].filter((item) => item.href);

  return (
    <Row wrap justify="center" gap="md" style={stylesheet.footer}>
      <AppText size="xs" tone={tone === "inverse" ? "inverse" : "default"}>
        {"\u00A9"} {new Date().getFullYear()} MintStint
      </AppText>
      {footerLinks.map((item) => (
        <AppLink
          key={item.label}
          href={item.href as never}
          target="_blank"
          tone={tone}
        >
          {item.label}
        </AppLink>
      ))}
    </Row>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    footer: {
      width: "100%",
      maxWidth: 1180,
      alignSelf: "center",
      marginTop: 48,
      paddingHorizontal: spacing.l,
      paddingVertical: 20,
      borderTopWidth: StyleSheet.hairlineWidth,
      borderTopColor: colors.border,
    },
  });
